import styles from './CarrelloContentEmpty.module.scss';

export type CarrelloContentEmptyProps = {
  title: string;
  description?: string;
  btnLabel?: string;
};

export const CarrelloContentEmpty = ({ title, description, btnLabel }: CarrelloContentEmptyProps) => {
  return (
    <div className={styles.container}>
      <p className={`${styles.title} ${description ? styles.withText : styles.withBtn}`}>{title}</p>
      {description && <p className={styles.text}>{description}</p>}
      {btnLabel && (
        <button type="button" className={styles.button}>
          {btnLabel}
        </button>
      )}
    </div>
  );
};
